<template>
  <div class="flex items-center">
    <a :href="$config.public.baseUrl" target="_blank">
      <img
        src="/_nuxt3-static/logos/logo-typo-only.svg"
        alt="Konfetti Logo"
        class="h-3.5 md:h-4"
      />
    </a>
    <span class="px-2 text-xs md:text-sm">
      {{ $t('widgets.generalBanner.title') }}
    </span>

    <img
      src="/_nuxt3-static/logos/konfetti-confettis.svg"
      alt="Confettis"
      class="h-3.5 md:h-4"
    />

    <span class="text-stone-500 pl-1.5 text-xs md:text-sm">
      {{
        $t('widgets.generalBanner.stars', {
          averageRating: averageRating?.toString(),
        })
      }}
      |
      {{
        $t('widgets.generalBanner.reviews', {
          totalReviews: totalReviews?.toString(),
        })
      }}
    </span>
  </div>
</template>
<script lang="ts" setup>
const { averageRating = 0, totalReviews = 0 } = defineProps<{
  averageRating: number
  totalReviews: number
}>()
</script>
